<template>
  <div>
    <page-header
      title="Reference Settings"
      breadcrumb="Dashboard > Settings > Dynamic Numbering System > Reference Settings"
    />
    <div class="custom-card flex flex-col gap-4">
      <div class="flex gap-3 items-center">
        <h3 class="font-semibold">Help</h3>
        <hr class="max-w-full" style="width: 90%;">
        <a href="#" class="font-normal flex gap-1 text-primary-yellow rotate-45 w-4"><img src="@/assets/images/icons/add.svg" />Close</a>
      </div>
      <p>
        References are used to generate codes when profiling any of the dynamic
        number entities. Here, you select which references you wish to use and
        how you want them to be applied in generating your code.
      </p>
      <p>
        References include mobile number, address, birthdays, alphanumeric code,
        country, states, cities etc.
      </p>
      <p>
        The applicable ways include use as-is (which uses the references as they
        are), first 3 characters (in the reference), last 3 characters (in the
        reference), use consonants (in the reference), use vowels (in the
        reference) or manual code (select and input codes applicable manually.
        Eg: If you choose “<span class="text-green">Country</span>” as reference, and application as “<span class="text-green">Manual Code</span>”, you have then to select the countries you wish to add, and
        manually input codes for them.)
      </p>
      <a class="text-green font-semibold flex gap-2 items-center">
        <img src="@/assets/images/icons/external-link.svg" alt="external link icon" />
        Learn More About Referencing
      </a>
      <hr>
      <div class="">
        <h3 class="font-semibold">References</h3>
        <div class="flex justify-between w-100">
          <div class="flex flex-col">
            <base-checkbox label="Show Alphanumeric Code" />
            <div class="flex flex-col gap-0 border-l border-dashed border-gray-500 ml-2 pl-2">
              <label for="" class="text-lightGrey">Max. Character Length</label>
              <div class="flex gap-2">
                <input type="number" class="border rounded border-gray-500 p-2 w-24" id="">
                <span class="bg-gray-100 p-2">Example: 59</span>
              </div>
            </div>
          </div>
          <div class="flex flex-col">
            <base-checkbox label="Show Alphanumeric Code" />
            <div class="flex flex-col gap-0 border-l border-dashed border-gray-500 ml-2 pl-2">
              <label for="" class="text-lightGrey">Max. Character Length</label>
              <div class="flex gap-2">
                <input type="number" class="border rounded border-gray-500 p-2 w-24" id="">
                <span class="bg-gray-100 p-2">Example: 59</span>
              </div>
            </div>
          </div>
          <div class="flex flex-col">
            <base-checkbox label="Show Alphanumeric Code" />
            <div class="flex flex-col gap-0 border-l border-dashed border-gray-500 ml-2 pl-2">
              <label for="" class="text-lightGrey">Max. Character Length</label>
              <div class="flex gap-2">
                <input type="number" class="border rounded border-gray-500 p-2 w-24" id="">
                <span class="bg-gray-100 p-2">Example: 59</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr>
      <div class="flex justify-between">
        <h3 class="font-medium">All Reference</h3>
        <a href="#" @click="showNewReferenceModal = true" class="flex gap-2 text-primary-yellow"><img src="@/assets/images/icons/add.svg" alt="add icon"> Add New Reference</a>
      </div>
      <table class="table">
        <thead>
          <tr>
            <th>REFERENCE</th>
            <th>APPLICATION</th>
            <th>MAX. CHARACTER LENGTH</th>
            <th>ACTIONS</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Mobile Number</td>
            <td>First 3 characters</td>
            <td><span class="text-red">Not set</span></td>
            <td class="flex">
              <span class="flex items-center px-2 text-green font-semibold cursor-pointer" @click="showEditReferenceModal = true">
                <span><img src="@/assets/images/icons/edit-box.svg" alt="edit icon"/></span>
                <span class="pl-1">Edit</span>
              </span>
              <span class="flex items-center px-2 text-red font-semibold cursor-pointer">
                <span><img src="@/assets/images/icons/delete-icon.svg" alt="delete icon"/></span>
                <span class="pl-1">Remove</span>
              </span>
            </td>
          </tr>
          <tr>
            <td>State/Province</td>
            <td>Vowels</td>
            <td>2</td>
            <td class="flex">
              <span class="flex items-center px-2 text-green font-semibold cursor-pointer" @click="showEditReferenceModal = true">
                <span><img src="@/assets/images/icons/edit-box.svg" alt="edit icon"/></span>
                <span class="pl-1">Edit</span>
              </span>
              <span class="flex items-center px-2 text-red font-semibold cursor-pointer">
                <span><img src="@/assets/images/icons/delete-icon.svg" alt="delete icon"/></span>
                <span class="pl-1">Remove</span>
              </span>
            </td>
          </tr>
          <tr>
            <td>City</td>
            <td>Manual Code</td>
            <td>3</td>
            <td class="flex">
              <span class="flex items-center px-2 text-green font-semibold cursor-pointer" @click="showEditReferenceModal = true">
                <span><img src="@/assets/images/icons/edit-box.svg" alt="edit icon"/></span>
                <span class="pl-1">Edit</span>
              </span>
              <span class="flex items-center px-2 text-red font-semibold cursor-pointer">
                <span><img src="@/assets/images/icons/delete-icon.svg" alt="delete icon"/></span>
                <span class="pl-1">Remove</span>
              </span>
            </td>
          </tr>
          <tr>
            <td>Identity Number</td>
            <td>Last 3 Character</td>
            <td>3</td>
            <td class="flex">
              <span class="flex items-center px-2 text-green font-semibold cursor-pointer" @click="showEditReferenceModal = true">
                <span><img src="@/assets/images/icons/edit-box.svg" alt="edit icon"/></span>
                <span class="pl-1">Edit</span>
              </span>
              <span class="flex items-center px-2 text-red font-semibold cursor-pointer">
                <span><img src="@/assets/images/icons/delete-icon.svg" alt="delete icon"/></span>
                <span class="pl-1">Remove</span>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="flex gap-4 justify-end">
        <base-button border="border" borderColor="border-gray-500" background="#fff" text="Cancel " />
        <base-button text="Save" />
      </div>
    </div>
    <new-reference-modal :showModal="showNewReferenceModal" @close-modal="showNewReferenceModal = false"/>
    <edit-reference-modal :showModal="showEditReferenceModal" @close-modal="showEditReferenceModal = false"/>
  </div>
</template>

<script>
import PageHeader from "@/components/UI/NewPageHeader";
import NewReferenceModal from "@/components/3pl/Settings/DNS/Modals/NewReferenceModal"
import EditReferenceModal from "@/components/3pl/Settings/DNS/Modals/EditReferenceModal"
export default {
  components: {
    PageHeader,
    EditReferenceModal,
    NewReferenceModal
  },
  data() {
    return {
      routeType: "",
      value1: "",
      showNewReferenceModal: false,
      showEditReferenceModal: false
    };
  },
};
</script>

<style lang="scss" scoped>
.table tr:nth-child(even){background-color: #F7F7FF;}
.table thead th, td {
  border: none !important;
}

</style>